import { render, staticRenderFns } from "./clients-table.vue?vue&type=template&id=19c2b1d5&scoped=true"
import script from "./clients-table.vue?vue&type=script&lang=js"
export * from "./clients-table.vue?vue&type=script&lang=js"
import style0 from "./clients-table.vue?vue&type=style&index=0&id=19c2b1d5&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c2b1d5",
  null
  
)

export default component.exports